module.exports = __webpack_public_path__ + "static/media/Grid.f9b5572f.svg";